/** Normalize the API's comma-separated codes without treating blanks or duplicates as currencies. */
export const parseActualsMultiCurrency = (value: unknown): string[] => {
  if (typeof value !== 'string') return []

  return [
    ...new Set(
      value
        .split(',')
        .map((code) => code.trim().toUpperCase())
        .filter((code) => /^[A-Z]{3}$/.test(code))
    ),
  ]
}

export const hasMultiLocalCurrencies = (value: unknown): boolean =>
  parseActualsMultiCurrency(value).filter((currency) => currency !== 'USD').length > 1
